module.exports = __webpack_public_path__ + "assets/img/wx_code.14501c41.png";